import { render, staticRenderFns } from "./addSeckillProduct.vue?vue&type=template&id=02d814a2&scoped=true"
import script from "./addSeckillProduct.vue?vue&type=script&lang=js"
export * from "./addSeckillProduct.vue?vue&type=script&lang=js"
import style0 from "./addSeckillProduct.vue?vue&type=style&index=0&id=02d814a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d814a2",
  null
  
)

component.options.__file = "addSeckillProduct.vue"
export default component.exports